var _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCasUsage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1010 1010",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC6E51",
    d: "M1010 505c0 278.904-226.106 505-505 505C226.086 1010 0 783.904 0 505S226.086 0 505 0c278.894 0 505 226.096 505 505z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M587.102 286.055h109.463c10.08 0 18.246 8.176 18.246 18.247v465.25c0 10.08-8.167 18.248-18.246 18.248H313.416c-10.08 0-18.247-8.167-18.247-18.247V304.302c0-10.07 8.166-18.247 18.247-18.247h109.482"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M696.564 797.9H313.416c-15.629 0-28.348-12.724-28.348-28.347V304.302c0-15.623 12.72-28.347 28.348-28.347h109.482v20.2H313.416c-4.493 0-8.147 3.65-8.147 8.147v465.25c0 4.499 3.654 8.148 8.147 8.148h383.149c4.488 0 8.147-3.65 8.147-8.147V304.302c0-4.498-3.66-8.147-8.148-8.147H587.101v-20.2h109.463c15.634 0 28.348 12.724 28.348 28.347v465.25c0 15.624-12.714 28.348-28.348 28.348z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB933",
    d: "M568.855 267.808s-27.36-5.938-27.36-9.114c0-20.17-16.354-36.494-36.495-36.494-20.16 0-36.494 16.323-36.494 36.494 0 3.176-27.36 9.114-27.36 9.114-10.081 0-18.248 8.176-18.248 18.247v36.494c0 10.07 8.167 18.247 18.247 18.247h127.71c10.06 0 18.247-8.177 18.247-18.247v-36.494c0-10.07-8.187-18.247-18.247-18.247z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M568.855 350.896h-127.71c-15.628 0-28.347-12.724-28.347-28.347v-36.494c0-15.229 12.063-27.686 27.134-28.327 7.166-1.579 14.573-3.581 18.859-5.03C461.74 229.833 481.338 212.1 505 212.1s43.26 17.734 46.21 40.597c4.285 1.45 11.692 3.452 18.858 5.03 15.07.642 27.134 13.1 27.134 28.328v36.494c0 15.623-12.719 28.347-28.347 28.347zM505 232.3c-14.553 0-26.394 11.836-26.394 26.394 0 8.354-5.336 12.477-35.32 18.977-.701.158-1.42.237-2.14.237-4.494 0-8.148 3.65-8.148 8.147v36.494c0 4.498 3.654 8.147 8.148 8.147h127.709c4.493 0 8.147-3.65 8.147-8.147v-36.494c0-4.498-3.654-8.147-8.147-8.147-.72 0-1.44-.079-2.14-.237-29.985-6.5-35.32-10.623-35.32-18.977 0-14.558-11.841-26.394-26.395-26.394z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 373.7,
    cy: 446.56,
    r: 40.4,
    fill: "#ACAF48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M373.7 470.941l-27.34-27.34 14.281-14.282 13.06 13.059 33.258-33.259 14.282 14.282-47.54 47.54z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.7,
    cy: 567.76,
    r: 40.4,
    fill: "#ACAF48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M373.7 592.143L346.36 564.8l14.281-14.282 13.06 13.06 33.258-33.26 14.282 14.283-47.54 47.54z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 373.7,
    cy: 688.96,
    r: 40.4,
    fill: "#ACAF48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M373.7 713.342L346.36 686l14.281-14.282 13.06 13.058 33.258-33.258 14.282 14.282-47.54 47.54zM676.7 436.46h-202v-20.2h202v20.2zM595.9 476.86H474.7v-20.2h121.2v20.2zM535.3 557.66h-60.6v-20.2h60.6v20.2zM676.7 557.66H555.5v-20.2h121.2v20.2zM636.3 598.06H474.7v-20.2h161.6v20.2zM676.7 678.86h-202v-20.2h202v20.2zM535.3 719.26h-60.6v-20.2h60.6v20.2zM616.1 719.26h-60.6v-20.2h60.6v20.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasUsage);
export default __webpack_public_path__ + "static/media/casUsage.3d42f1f0666672b53d400c9fec5682b2.svg";
export { ForwardRef as ReactComponent };